import { useMemo } from "react";
import { Link } from "react-router";
import LogoutLink from "@core/layouts/header/components/common/LogoutLink";
import NcfzLogoutLink from "@core/layouts/header/components/common/NcfzLogoutLink";
import { useAuthStore } from "@core/stores/authStore";
import { useUiStore } from "@core/stores/uiStore";
import { cn } from "@core/utils/domUtil";

export default function LinkUtil() {
  const auth = useAuthStore((state) => state.auth);
  const isPcView = useUiStore((state) => state.isPcView());
  const btnVariant = useMemo(() => (isPcView ? "text" : "borderBgWhite"), [isPcView]);
  const btnSize = useMemo(() => (isPcView ? "small" : "large"), [isPcView]);

  return (
    <div className="w-full border-t border-gray-200 pt-[16px]">
      <ul className="items-center justify-between max-lg:block lg:flex">
        <li className="flex-1 text-center">
          <Link to="/account/user" className={cn("text-md max-lg:flex max-lg:h-[44px] max-lg:w-full max-lg:items-center max-lg:justify-center max-lg:rounded-lg max-lg:border max-lg:border-gray-300")}>
            내 정보 관리
          </Link>
        </li>
        <li className={cn("relative flex-1 text-center", "max-lg:mt-[12px]", "before:absolute before:top-1/2 before:left-0 before:h-[14px] before:w-[1px] before:-translate-y-1/2 before:bg-gray-200")}>
          {auth === "NCFZ_USER_0" || auth === "NCFZ_USER_1" ? (
            <NcfzLogoutLink variant={btnVariant} size={btnSize} className="max-lg:w-full" />
          ) : (
            <LogoutLink variant={btnVariant} size={btnSize} className="max-lg:w-full" />
          )}
        </li>
      </ul>
    </div>
  );
}
